export const getTrendText = (percentage: number): string => {
  if (percentage > 0) return 'maior que ano passado'
  if (percentage < 0) return 'menor que ano passado'
  return 'igual ao ano passado'
}
